// Mock data for Pazzo Pizzeria

export const menuData = {
  pizzas: [
    {
      id: 1,
      name: "Margherita Classica",
      price: 24,
      description: "San Marzano tomatoes, fresh mozzarella, basil, extra virgin olive oil",
      image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      name: "Diavola Piccante",
      price: 28,
      description: "Spicy Italian salami, mozzarella, chili flakes, oregano",
      image: "https://images.unsplash.com/photo-1750127060930-ea1cdc1e59a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhcnRpc2FuYWwlMjBwaXp6YXxlbnwwfHx8fDE3NjAwODgxMTl8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      name: "Quattro Formaggi",
      price: 26,
      description: "Mozzarella, gorgonzola, parmesan, fontina, truffle oil",
      image: "https://images.unsplash.com/photo-1682264788192-9abdec90c425?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      name: "Prosciutto e Rucola",
      price: 29,
      description: "Prosciutto di Parma, arugula, cherry tomatoes, shaved parmesan",
      image: "https://images.unsplash.com/photo-1598023696416-0193a0bcd302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxwaXp6YSUyMG1hcmdoZXJpdGF8ZW58MHx8fHwxNzYwMDg4MTMzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 5,
      name: "Funghi Tartufo",
      price: 32,
      description: "Wild mushrooms, truffle cream, mozzarella, thyme",
      image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 6,
      name: "Capricciosa",
      price: 27,
      description: "Ham, mushrooms, artichokes, olives, mozzarella",
      image: "https://images.unsplash.com/photo-1682264788192-9abdec90c425?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85"
    }
  ],
  loadedFries: [
    {
      id: 7,
      name: "Truffle Parmesan Fries",
      price: 16,
      description: "Crispy fries, truffle oil, parmesan, fresh herbs",
      image: "https://images.unsplash.com/photo-1639744210631-209fce3e256c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsb2FkZWQlMjBmcmllc3xlbnwwfHx8fDE3NjAwODgxNjJ8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 8,
      name: "Bacon & Cheese Fries",
      price: 14,
      description: "Loaded with crispy bacon, melted cheese, sour cream",
      image: "https://images.unsplash.com/photo-1485962398705-ef6a13c41e8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsb2FkZWQlMjBmcmllc3xlbnwwfHx8fDE3NjAwODgxNjJ8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 9,
      name: "Pazzo Special Fries",
      price: 18,
      description: "Italian sausage, mozzarella, marinara, jalapeños",
      image: "https://images.unsplash.com/photo-1639744210631-209fce3e256c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsb2FkZWQlMjBmcmllc3xlbnwwfHx8fDE3NjAwODgxNjJ8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  saladBowls: [
    {
      id: 10,
      name: "Caesar Salad Bowl",
      price: 15,
      description: "Romaine lettuce, parmesan, croutons, Caesar dressing",
      image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzYwMDg4MTY2fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 11,
      name: "Mediterranean Bowl",
      price: 17,
      description: "Mixed greens, feta, olives, tomatoes, cucumber, lemon vinaigrette",
      image: "https://images.unsplash.com/photo-1546069901-d5bfd2cbfb1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzYwMDg4MTY2fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 12,
      name: "Chicken Avocado Bowl",
      price: 19,
      description: "Grilled chicken, avocado, cherry tomatoes, mixed greens, balsamic",
      image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzYwMDg4MTY2fDA&ixlib=rb-4.1.0&q=85"
    }
  ],
  calzones: [
    {
      id: 13,
      name: "Classic Calzone",
      price: 22,
      description: "Ricotta, mozzarella, ham, mushrooms, marinara sauce",
      image: "https://images.unsplash.com/photo-1628824851008-ec3ab4b45527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjYWx6b25lfGVufDB8fHx8MTc2MDA4ODE3MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 14,
      name: "Spinach & Ricotta Calzone",
      price: 20,
      description: "Fresh spinach, ricotta, mozzarella, garlic, herbs",
      image: "https://images.unsplash.com/photo-1628824851008-ec3ab4b45527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjYWx6b25lfGVufDB8fHx8MTc2MDA4ODE3MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 15,
      name: "Meat Lovers Calzone",
      price: 25,
      description: "Italian sausage, pepperoni, bacon, mozzarella, marinara",
      image: "https://images.unsplash.com/photo-1628824851008-ec3ab4b45527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjYWx6b25lfGVufDB8fHx8MTc2MDA4ODE3MXww&ixlib=rb-4.1.0&q=85"
    }
  ],
  snacks: [
    {
      id: 16,
      name: "Mozzarella Sticks",
      price: 12,
      description: "Crispy breaded mozzarella, marinara dipping sauce",
      image: "https://images.unsplash.com/photo-1734774924912-dcbb467f8599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb3p6YXJlbGxhJTIwc3RpY2tzfGVufDB8fHx8MTc2MDA4ODE5OXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 17,
      name: "Chicken Nuggets",
      price: 11,
      description: "Golden fried chicken bites, honey mustard sauce",
      image: "https://images.unsplash.com/photo-1627662168223-7df99068099a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjaGlja2VuJTIwbnVnZ2V0c3xlbnwwfHx8fDE3NjAwODgyMDV8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 18,
      name: "Garlic Bread",
      price: 8,
      description: "Toasted bread, garlic butter, parsley, parmesan",
      image: "https://images.pexels.com/photos/33649030/pexels-photo-33649030.jpeg"
    },
    {
      id: 19,
      name: "Bruschetta",
      price: 10,
      description: "Fresh tomatoes, basil, garlic, olive oil on toasted bread",
      image: "https://images.pexels.com/photos/33649030/pexels-photo-33649030.jpeg"
    }
  ]
};

export const galleryImages = [
  "https://images.unsplash.com/photo-1532117472055-4d0734b51f31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcmVzdGF1cmFudHxlbnwwfHx8fDE3NjAwODgyMTB8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1593548615309-5a45c504f994?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcmVzdGF1cmFudHxlbnwwfHx8fDE3NjAwODgyMTB8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg",
  "https://images.unsplash.com/photo-1668686376776-df5a9b838896",
  "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1750127060930-ea1cdc1e59a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxhcnRpc2FuYWwlMjBwaXp6YXxlbnwwfHx8fDE3NjAwODgxMTl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1682264788192-9abdec90c425?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcGl6emF8ZW58MHx8fHwxNzYwMDg4MTEzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1598023696416-0193a0bcd302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxwaXp6YSUyMG1hcmdoZXJpdGF8ZW58MHx8fHwxNzYwMDg4MTMzfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1639744210631-209fce3e256c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsb2FkZWQlMjBmcmllc3xlbnwwfHx8fDE3NjAwODgxNjJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzYWxhZCUyMGJvd2x8ZW58MHx8fHwxNzYwMDg4MTY2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1734774924912-dcbb467f8599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb3p6YXJlbGxhJTIwc3RpY2tzfGVufDB8fHx8MTc2MDA4ODE5OXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1627662168223-7df99068099a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjaGlja2VuJTIwbnVnZ2V0c3xlbnwwfHx8fDE3NjAwODgyMDV8MA&ixlib=rb-4.1.0&q=85"
];

export const locations = [
  {
    id: 1,
    name: "Pazzo Helsinki",
    address: "Kirkonkyläntie 34, 00700 Helsinki",
    phone: "0413289889",
    hours: "Mon-Thur: 10:30-21:00 | Fri: 10:30-22:00 | Sat: 11:00-22:00 | Sun: 11:00-21:00",
    image: "https://images.unsplash.com/photo-1759419038843-29749ac4cd2d"
  }
];